export default __webpack_public_path__ + "static/media/amex.49e2b2a6.png";